import { DateTime } from 'luxon';
import { relatedLocations } from './related-locations.fixture';
import { kitchenThrottleConfig } from './kitchen-throttle-config.fixture';
import { StoreOrderingResponse } from '../ordering-service.types';

export const baseLocation: StoreOrderingResponse = {
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  locationId: '985487d9-f4bf-4f57-a964-436d2fca267a',
  paymentConfigs: [
    {
      orderType: 'DELIVERY',
      paymentModes: ['PAYMENT_OPTIONAL'],
      placePOSOrdersAsOpen: true,
      guestCheckoutSupported: true,
    },
    {
      orderType: 'PICKUP',
      paymentModes: ['PAYMENT_OPTIONAL'],
      placePOSOrdersAsOpen: true,
      guestCheckoutSupported: true,
    },
  ],
  orderProcessingConfig: {
    orderProcessingStrategy: 'TWO_STEP',
    paymentIDGenerationStrategy: 'UUID',
    paymentGatewayName: 'incentivio-conpay-spreedly',
    orderGatewayName: 'incentivio-connector-toast',
    externalDeliverySettings: null,
    roundingMode: 'HALF_EVEN',
    calculationStrategy: 'TOAST',
    consolidateMultipleDiscounts: false,
    realTimeLoyaltyProcessing: false,
  },
  paymentGatewayConfig: {
    extendedAttributes: {
      GATEWAY_TOKEN: '5nEUrCnojF40TCcDVmrqlo6QAhN',
      SPREEDLY_ENV_KEY: 'ZJT3yOVE0uCu156WjfF95wK9J1w',
      PAYMENT_PROCESSOR: 'TOAST',
      TEST_GATEWAY_TOKEN: 'XL24KvdDHFtWAE7LjjD5dI20THj',
      ORG_ACCESS_SECRET:
        'khUKJRP4jF8NNW4uc4U066xiM8kC5kQLGf1WUPUx41rrATDh5jpdCfi8yVBhqqnG',
      APPLE_PAY_ENABLED: 'true',
      ANDROID_PAY_ENABLED: 'false',
      TEST_GOOGLE_PAY_PAYMENT: 'true',
      TEST_GOOGLE_PAY_PAYMENT_CARD_NUMBER: '4111111111111111',
    },
  },
  pickupOrderProcessingTime: 15,
  deliveryOrderProcessingTime: 5,
  pickupOrderNoticePeriod: 0,
  deliveryOrderNoticePeriod: 0,
  timeZone: 'Asia/Colombo',
  taxes: [],
  charges: [
    {
      chargeId: '9b480ef3-64ab-4ddc-93d0-2450d6e3f99c',
      chargeName: null,
      extChargeId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
      chargeDescription: 'Delivery Charge',
      chargeType: 'AMOUNT',
      amount: 100000,
      percentage: null,
      taxable: false,
      gratuity: false,
      delivery: true,
      orderApplied: null,
      applicableOrderTypes: ['DELIVERY'],
      extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
      applicableEntity: null,
      rules: [],
      taxes: null,
    },
  ],
  pickupOrdersAccepted: true,
  deliveryOrdersAccepted: true,
  pickupOrderHours: [
    {
      dayOfWeek: 'THURSDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'SUNDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'TUESDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'WEDNESDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'SATURDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'MONDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
    {
      dayOfWeek: 'FRIDAY',
      startTime: '00:00:00',
      endTime: '23:59:59',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
    },
  ],
  deliveryOrderHours: [
    {
      dayOfWeek: 'THURSDAY',
      startTime: '00:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
    },
    {
      dayOfWeek: 'SUNDAY',
      startTime: '00:00:00',
      endTime: '12:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '12:00:00' }],
    },
    {
      dayOfWeek: 'TUESDAY',
      startTime: '00:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
    },
    {
      dayOfWeek: 'WEDNESDAY',
      startTime: '00:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
    },
    {
      dayOfWeek: 'SATURDAY',
      startTime: '00:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
    },
    {
      dayOfWeek: 'MONDAY',
      startTime: '08:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '08:00:00', endTime: '23:00:00' }],
    },
    {
      dayOfWeek: 'FRIDAY',
      startTime: '00:00:00',
      endTime: '23:00:00',
      timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
    },
  ],
  deliveryOffDays: [],
  pickupOffDays: [],
  deliveryRadius: 3000.0,
  latitude: 18.46554,
  longitude: -66.105736,
  deliveryAvailabilityInterval: 4,
  pickupAvailabilityInterval: 5,
  extendedAttributes: {},
  locationName: 'WOV2 Test Store - DO NOT EDIT QA',
  externalOrderingEnabled: false,
  externalOrderingText: '',
  showPickupTimeSlots: false,
  showDeliveryTimeSlots: false,
  pickupAsapSupported: true,
  deliveryAsapSupported: true,
  countryCode: null,
  currencyCode: null,
  menuImportConfig: {
    connectorGatewayName: 'incentivio-connector-toast',
    extStoreId: null,
    defaultLanguage: 'EN',
    connectorName: 'TOAST CONNECTOR',
    overrideExistingImages: false,
    importType: 'INDEPENDANT_MENU_IMPORT',
    extendedAttributes: {},
  },
  orderThrottleConfig: [
    {
      applicableOrderTypes: ['DELIVERY'],
      throttleSettings: {
        SUNDAY: [
          {
            timeSlot: { startTime: '10:00:00', endTime: '20:00:00' },
            throttleSettings: [
              {
                orderAmount: 10000,
                processingTime: 50,
                displayMessage: { EN: 'We need more time!' },
              },
            ],
          },
        ],
      },
    },
    {
      applicableOrderTypes: ['PICKUP'],
      throttleSettings: {
        MONDAY: [
          {
            timeSlot: { startTime: '10:00:00', endTime: '23:00:00' },
            throttleSettings: [
              {
                orderAmount: 0,
                processingTime: 150,
                displayMessage: { EN: 'We Need More Time' },
              },
              {
                orderAmount: 10000,
                processingTime: 50,
                displayMessage: { EN: 'We  need more time' },
              },
            ],
          },
        ],
        SUNDAY: [
          {
            timeSlot: { startTime: '10:00:00', endTime: '23:00:00' },
            throttleSettings: [
              {
                orderAmount: 0,
                processingTime: 30,
                displayMessage: { EN: 'We need more Time' },
              },
              {
                orderAmount: 10000,
                processingTime: 50,
                displayMessage: { EN: 'We need more time' },
              },
            ],
          },
        ],
        THURSDAY: [
          {
            timeSlot: { startTime: '00:00:00', endTime: '04:59:59' },
            throttleSettings: [
              {
                orderAmount: 10000,
                processingTime: 130,
                displayMessage: { EN: 'asdf' },
              },
            ],
          },
        ],
        TUESDAY: [
          {
            timeSlot: { startTime: '00:00:00', endTime: '23:59:59' },
            throttleSettings: [
              {
                orderAmount: 20000,
                processingTime: 45,
                displayMessage: { EN: 'Order value > $20, Time = 45' },
              },
              {
                orderAmount: 0,
                processingTime: 30,
                displayMessage: { EN: '30 mins needed' },
              },
            ],
          },
        ],
      },
    },
  ],
  pickupOrderValueLimits: null,
  deliveryOrderValueLimits: {
    minOrderValue: 10000.0,
    maxOrderValue: 50000.0,
    displayMessage: [
      {
        langCode: 'EN',
        shortMessage: 'Min required $10 Max $50',
        longMessage: 'Min required $10 Max $50',
      },
    ],
  },
  catalogOverrides: null,
  groupOverrides: [
    {
      catalogId: '61f37aa8e4b078328b667b33',
      groupId: '60ab97d560b2e6d06e88dadb',
      applicableOrderTypes: ['PICKUP'],
      override: { THURSDAY: [{ startTime: '12:00:00', endTime: '22:00:00' }] },
    },
    {
      catalogId: '61f37aa8e4b078328b667b33',
      groupId: '60ab97d560b2e6d06e88dae8',
      applicableOrderTypes: ['DELIVERY'],
      override: {
        FRIDAY: [{ startTime: '00:00:00', endTime: '23:59:59' }],
        THURSDAY: [{ startTime: '12:00:00', endTime: '23:59:59' }],
      },
    },
  ],
  orderNotificationRecipientEmailList: ['heshani.s@incentivio.com'],
  failureNotificationRecipientEmailList: ['heshani.s@incentivio.com'],
  pickupOrderOptions: [],
  deliveryOrderOptions: [
    {
      optionName: 'Fore Here',
      displayRank: 0,
      enableInformationField: true,
      makeInformationFieldMandatory: false,
      enableInstructions: false,
      enableImHere: false,
      channelsForOrderReceivedNotification: ['SMS', 'EMAIL'],
      channelsForOrderCompleteNotification: ['SMS', 'EMAIL'],
      displayMessage: [
        {
          langCode: 'EN',
          title: 'ForHere',
          informationField: 'Enter your car number',
          imHereResponseMessage: null,
          errorMessageIfInformationFieldIsEmpty: null,
          instructions: null,
          orderConfirmationMessage:
            'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
          orderClosedMessage:
            'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
          smsOrderConfirmationMessage:
            'Hey [#Customer#], your [#Order Option Display Title#] order from [#Merchant Name#] will be ready at [#Required Time#].',
          smsOrderClosedMessage:
            'Hey [#Customer#], your order from [#Merchant Name#] is complete!',
        },
      ],
    },
  ],
  deliveryArea: { deliveryAreaType: 'CIRCLE', deliveryAreaPolygon: null },
  deliveryTemporaryHours: [],
  pickupTemporaryHours: [
    {
      startDate: null,
      endDate: null,
      sameHoursPerDate: {
        dayOfWeek: 'WEDNESDAY',
        timeSlots: [],
        startTime: null,
        endTime: null,
      },
      diffHoursPerDate: null,
    },
  ],
  deliveryMaxDaysOut: 0,
  deliverySevenPlusDaysOrdering: false,
  kitchenThrottleConfig: kitchenThrottleConfig.kitchenThrottleConfig,
  extPosLocationId: '1303e122-14d6-46c7-9aa6-9cfd0a2e849f',
  primaryLocation: true,
  disableTipping: false,
  primaryStore: null,
  relatedStores: [],
  qalocation: false,
  test: false,
  enableFulFillTextForToast: false,
  pickupMaxDaysOut: 0,
  pickupSevenPlusDaysOrdering: false,
  primaryLocationId: null,
};

export const stores: StoreOrderingResponse[] = [
  {
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    locationId: '985487d9-f4bf-4f57-a964-436d2fca267a',
    enableFulFillTextForToast: null,
    dynamicDeliveryCharge: {
      chargeId: null,
      extChargeId: null,
      chargeName: null,
      chargeDescription: 'test ppppp',
      chargeType: 'AMOUNT',
      amount: 5000,
      percentage: null,
      taxable: false,
      gratuity: false,
      delivery: false,
      orderApplied: null,
      applicableOrderTypes: ['DELIVERY'],
      extTaxId: null,
      taxes: [
        {
          amount: 4,
          applicableEntity: null,
          applicableOrderTypes: null,
          extTaxId: 'dd',
          percentage: 0,
          rules: null,
          taxDescription: 'new tax',
          taxId: null,
          taxType: 'AMOUNT',
        },
      ],
      applicableEntity: 'ORDER',
      rules: [{ amount: 3, operator: 'EQ' }],
      chargeApplied: null,
      chargeTiers: [
        {
          amount: 7,
          percentage: null,
          extChargeId: null,
          minDistance: 0.0,
        },
      ],
    },
    primaryLocationId: null,
    paymentConfigs: [
      {
        orderType: 'DELIVERY',
        paymentModes: ['PAYMENT_OPTIONAL'],
        placePOSOrdersAsOpen: true,
        guestCheckoutSupported: true,
      },
      {
        orderType: 'PICKUP',
        paymentModes: ['PAYMENT_OPTIONAL'],
        placePOSOrdersAsOpen: true,
        guestCheckoutSupported: true,
      },
    ],
    orderProcessingConfig: {
      orderProcessingStrategy: 'TWO_STEP',
      paymentIDGenerationStrategy: 'UUID',
      paymentGatewayName: 'incentivio-conpay-spreedly',
      orderGatewayName: 'incentivio-connector-toast',
      externalDeliverySettings: null,
      roundingMode: 'HALF_EVEN',
      calculationStrategy: 'TOAST',
      consolidateMultipleDiscounts: false,
      realTimeLoyaltyProcessing: false,
    },
    paymentGatewayConfig: {
      extendedAttributes: {
        GATEWAY_TOKEN: '5nEUrCnojF40TCcDVmrqlo6QAhN',
        SPREEDLY_ENV_KEY: 'ZJT3yOVE0uCu156WjfF95wK9J1w',
        PAYMENT_PROCESSOR: 'TOAST',
        TEST_GATEWAY_TOKEN: 'XL24KvdDHFtWAE7LjjD5dI20THj',
        ORG_ACCESS_SECRET:
          'khUKJRP4jF8NNW4uc4U066xiM8kC5kQLGf1WUPUx41rrATDh5jpdCfi8yVBhqqnG',
        APPLE_PAY_ENABLED: 'true',
        ANDROID_PAY_ENABLED: 'false',
        TEST_GOOGLE_PAY_PAYMENT: 'true',
        TEST_GOOGLE_PAY_PAYMENT_CARD_NUMBER: '4111111111111111',
      },
    },
    pickupOrderProcessingTime: 15,
    deliveryOrderProcessingTime: 5,
    pickupOrderNoticePeriod: 0,
    deliveryOrderNoticePeriod: 0,
    timeZone: 'Asia/Kabul',
    taxes: [],
    charges: [
      {
        chargeId: 'f572e6fa-732c-479a-9ca7-7e0b608876c5',
        chargeName: null,
        extChargeId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
        chargeDescription: 'Delivery Charge',
        chargeType: 'AMOUNT',
        amount: 100000,
        percentage: null,
        taxable: false,
        gratuity: false,
        delivery: true,
        orderApplied: null,
        applicableOrderTypes: ['DELIVERY'],
        extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
        applicableEntity: null,
        rules: [],
        taxes: null,
      },
    ],
    pickupOrdersAccepted: true,
    pickupMaxDaysOut: 12,
    pickupSevenPlusDaysOrdering: true,
    deliveryOrdersAccepted: true,
    pickupOrderHours: [
      {
        dayOfWeek: 'TUESDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'THURSDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'WEDNESDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'SUNDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'FRIDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'MONDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
      {
        dayOfWeek: 'SATURDAY',
        startTime: '00:00:00',
        endTime: '23:59:59',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:59:59' }],
      },
    ],
    deliveryOrderHours: [
      {
        dayOfWeek: 'TUESDAY',
        startTime: '00:00:00',
        endTime: '23:00:00',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
      },
      {
        dayOfWeek: 'THURSDAY',
        startTime: '00:00:00',
        endTime: '23:00:00',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
      },
      {
        dayOfWeek: 'SUNDAY',
        startTime: '00:00:00',
        endTime: '12:00:00',
        timeSlots: [{ startTime: '00:00:00', endTime: '12:00:00' }],
      },
      {
        dayOfWeek: 'MONDAY',
        startTime: '08:00:00',
        endTime: '23:00:00',
        timeSlots: [{ startTime: '08:00:00', endTime: '23:00:00' }],
      },
      {
        dayOfWeek: 'SATURDAY',
        startTime: '00:00:00',
        endTime: '23:00:00',
        timeSlots: [{ startTime: '00:00:00', endTime: '23:00:00' }],
      },
    ],
    deliveryOffDays: [],
    pickupOffDays: [],
    deliveryRadius: 3000.0,
    latitude: 18.46554,
    longitude: -66.105736,
    deliveryAvailabilityInterval: 4,
    pickupAvailabilityInterval: 5,
    extendedAttributes: {
      TOAST_RESTAURANT_ID: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      PICKUP_DINING_OPTION_GUID: '2105b4d9-91b0-476e-a9e8-de4d98bfe3d6',
      DELIVERY_DINING_OPTION_GUID: '491b6e2d-e87b-4feb-8f3b-7af4710fc7c3',
      OTHER_PAYMENT_GUID: '68a283e4-344e-4e3e-886d-979c9ac01698',
      OPEN_DISCOUNT_GUID: '2219f17b-f2e4-4516-a119-1e1c74835040',
      ITEM_FALLBACK_OFFER_ID: '4c655254-3b8a-44fc-a246-831d44254841',
    },
    locationName: 'WOV2 Test Store - DO NOT EDIT QA',
    externalOrderingEnabled: false,
    externalOrderingText: '',
    showPickupTimeSlots: true,
    showDeliveryTimeSlots: true,
    pickupAsapSupported: true,
    deliveryAsapSupported: true,
    countryCode: null,
    currencyCode: 'USD',
    menuImportConfig: {
      connectorGatewayName: 'incentivio-connector-toast',
      extStoreId: null,
      defaultLanguage: 'EN',
      connectorName: 'TOAST CONNECTOR',
      overrideExistingImages: false,
      importType: 'INDEPENDANT_MENU_IMPORT',
      extendedAttributes: {
        RUN_AUTO_IMPORTS: 'true',
        USE_86ING: 'true',
        RETAIN_TAX_SETTINGS: 'true',
        OVERRIDE_DISPLAYINFO_DESCRIPTIONS: 'true',
        cleanimport: 'false',
        VISIBILITY: 'Incentivio',
        EXT_STORE_GUID: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
        OVERRIDE_DISPLAYINFO_TITLE: 'true',
        RETAIN_STATUS: 'false',
      },
    },
    orderThrottleConfig: [
      {
        applicableOrderTypes: ['PICKUP'],
        throttleSettings: {
          MONDAY: [
            {
              timeSlot: { startTime: '10:00:00', endTime: '23:00:00' },
              throttleSettings: [
                {
                  orderAmount: 0,
                  processingTime: 150,
                  displayMessage: { EN: 'We Need More Time' },
                },
                {
                  orderAmount: 10000,
                  processingTime: 50,
                  displayMessage: { EN: 'We  need more time' },
                },
              ],
            },
          ],
          SUNDAY: [
            {
              timeSlot: { startTime: '10:00:00', endTime: '23:00:00' },
              throttleSettings: [
                {
                  orderAmount: 0,
                  processingTime: 30,
                  displayMessage: { EN: 'We need more Time' },
                },
                {
                  orderAmount: 10000,
                  processingTime: 50,
                  displayMessage: { EN: 'We need more time' },
                },
              ],
            },
          ],
          THURSDAY: [
            {
              timeSlot: { startTime: '00:00:00', endTime: '04:59:59' },
              throttleSettings: [
                {
                  orderAmount: 10000,
                  processingTime: 130,
                  displayMessage: { EN: 'asdf' },
                },
              ],
            },
          ],
          TUESDAY: [
            {
              timeSlot: { startTime: '00:00:00', endTime: '23:59:59' },
              throttleSettings: [
                {
                  orderAmount: 20000,
                  processingTime: 45,
                  displayMessage: { EN: 'Order value > $20, Time = 45' },
                },
                {
                  orderAmount: 0,
                  processingTime: 30,
                  displayMessage: { EN: '30 mins needed' },
                },
              ],
            },
          ],
        },
      },
      {
        applicableOrderTypes: ['DELIVERY'],
        throttleSettings: {
          SUNDAY: [
            {
              timeSlot: { startTime: '10:00:00', endTime: '20:00:00' },
              throttleSettings: [
                {
                  orderAmount: 10000,
                  processingTime: 50,
                  displayMessage: { EN: 'We need more time!' },
                },
              ],
            },
          ],
        },
      },
    ],
    pickupOrderValueLimits: null,
    deliveryOrderValueLimits: {
      minOrderValue: 10000.0,
      maxOrderValue: 50000.0,
      displayMessage: [
        {
          langCode: 'EN',
          shortMessage: 'Min required $10 Max $50',
          longMessage: 'Min required $10 Max $50',
        },
      ],
    },
    catalogOverrides: null,
    groupOverrides: [
      {
        catalogId: '61f37aa8e4b078328b667b33',
        groupId: '60ab97d560b2e6d06e88dadb',
        applicableOrderTypes: ['PICKUP'],
        override: {
          THURSDAY: [{ startTime: '12:00:00', endTime: '22:00:00' }],
        },
      },
      {
        catalogId: '61f37aa8e4b078328b667b33',
        groupId: '60ab97d560b2e6d06e88dae8',
        applicableOrderTypes: ['DELIVERY'],
        override: {
          FRIDAY: [{ startTime: '00:00:00', endTime: '23:59:59' }],
          THURSDAY: [{ startTime: '12:00:00', endTime: '23:59:59' }],
        },
      },
    ],
    orderNotificationRecipientEmailList: ['rashmi.s@aeturnum.com'],
    failureNotificationRecipientEmailList: ['rashmi.s@aeturnum.com'],
    pickupOrderOptions: [],
    deliveryOrderOptions: [
      {
        optionName: 'Fore Here',
        displayRank: 0,
        enableInformationField: true,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: false,
        channelsForOrderReceivedNotification: ['SMS', 'EMAIL'],
        channelsForOrderCompleteNotification: ['SMS', 'EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'ForHere',
            informationField: 'Fore here info',
            imHereResponseMessage: null,
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: 'sms message',
            smsOrderClosedMessage: 'sms message',
          },
        ],
      },
    ],
    deliveryTemporaryHours: [],
    pickupTemporaryHours: [],
    deliveryArea: { deliveryAreaType: 'CIRCLE', deliveryAreaPolygon: null },
    deliveryMaxDaysOut: 0,
    deliverySevenPlusDaysOrdering: false,
    kitchenThrottleConfig: kitchenThrottleConfig.kitchenThrottleConfig,
    extPosLocationId: '1303e122-14d6-46c7-9aa6-9cfd0a2e849f',
    primaryLocation: true,
    disableTipping: false,
    primaryStore: null,
    relatedStores: [],
    qalocation: false,
    test: false,
  },
  {
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
    locationId: 'a8bd1f53-6172-4f1f-b78b-50c7cf052151',
    enableFulFillTextForToast: true,
    fulFillTextForToast: 'test fulfill text',
    paymentConfigs: [
      {
        orderType: 'DELIVERY',
        paymentModes: ['PAYMENT_MANDATORY'],
        placePOSOrdersAsOpen: false,
        guestCheckoutSupported: true,
      },
      {
        orderType: 'PICKUP',
        paymentModes: ['PAYMENT_MANDATORY'],
        placePOSOrdersAsOpen: false,
        guestCheckoutSupported: true,
      },
    ],
    orderProcessingConfig: {
      orderProcessingStrategy: 'INCENTIVIO_ORDER',
      paymentIDGenerationStrategy: 'UUID',
      paymentGatewayName: 'incentivio-conpay-spreedly',
      orderGatewayName: 'incentivio-order',
      externalDeliverySettings: null,
      roundingMode: 'HALF_EVEN',
      calculationStrategy: 'SILVERWARE',
      consolidateMultipleDiscounts: false,
      realTimeLoyaltyProcessing: false,
    },
    paymentGatewayConfig: {
      extendedAttributes: {
        GATEWAY_TOKEN: 'XL24KvdDHFtWAE7LjjD5dI20THj',
        SPREEDLY_ENV_KEY: 'ZJT3yOVE0uCu156WjfF95wK9J1w',
        APPLE_PAY_ENABLED: 'true',
        ANDROID_PAY_ENABLED: 'false',
        TEST_GOOGLE_PAY_PAYMENT: 'true',
        TEST_GOOGLE_PAY_PAYMENT_CARD_NUMBER: '4111111111111111',
        PAYMENT_PROCESSOR: 'TEST',
        TEST_GATEWAY_TOKEN: 'XL24KvdDHFtWAE7LjjD5dI20THj',
        TEST_APPLE_PAY_PAYMENT: 'true',
        TEST_APPLE_PAY_PAYMENT_CARD_NUMBER: '4111111111111111',
        ORG_ACCESS_SECRET:
          'khUKJRP4jF8NNW4uc4U066xiM8kC5kQLGf1WUPUx41rrATDh5jpdCfi8yVBhqqnG',
      },
    },
    pickupOrderProcessingTime: 15,
    deliveryOrderProcessingTime: 20,
    pickupOrderNoticePeriod: 0,
    deliveryOrderNoticePeriod: 0,
    timeZone: 'Asia/Colombo',
    taxes: [
      {
        taxId: null,
        extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
        taxDescription: 'State Tax',
        taxType: 'PERCENTAGE',
        amount: 0,
        percentage: 0.02,
        applicableOrderTypes: ['PICKUP', 'DELIVERY'],
        applicableEntity: 'ORDER',
        rules: null,
      },
      {
        taxId: null,
        extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d273',
        taxDescription: 'City Tax',
        taxType: 'AMOUNT',
        amount: 5670,
        percentage: 0.0,
        applicableOrderTypes: ['PICKUP', 'DELIVERY'],
        applicableEntity: 'ORDER',
        rules: [{ amount: 2003, operator: 'LT' }],
      },
    ],
    charges: [
      {
        chargeId: '20c0c08a-1a53-4b7c-b6db-07358188a89a',
        chargeName: null,
        extChargeId: null,
        chargeDescription: 'Packing Charge',
        chargeType: 'AMOUNT',
        amount: 1500,
        percentage: null,
        taxable: true,
        gratuity: false,
        delivery: true,
        orderApplied: null,
        applicableOrderTypes: ['PICKUP', 'DELIVERY'],
        extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
        applicableEntity: null,
        rules: [],
        taxes: [
          {
            amount: 6,
            applicableEntity: null,
            applicableOrderTypes: null,
            extTaxId: 'sssss',
            percentage: null,
            rules: null,
            taxDescription: 'abc tax to charge',
            taxType: 'AMOUNT',
          },
        ],
      },
      {
        chargeId: '0954dd98-4d7f-44ea-8f57-950ae294c0c6',
        chargeName: null,
        extChargeId: null,
        chargeDescription: 'Delivery ChargeTX',
        chargeType: 'AMOUNT',
        amount: 3990,
        percentage: null,
        taxable: true,
        gratuity: false,
        delivery: true,
        orderApplied: null,
        applicableOrderTypes: ['DELIVERY'],
        extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
        applicableEntity: null,
        rules: [{ amount: 29000, operator: 'GT' }],
        taxes: [
          {
            taxId: null,
            extTaxId: 'e1109b11-f117-4f22-b2c6-98e2e954d279',
            taxDescription: 'Delivery Charge Tax',
            taxType: 'PERCENTAGE',
            amount: 0,
            percentage: 0.1,
            applicableOrderTypes: null,
            applicableEntity: null,
            rules: null,
          },
        ],
      },
    ],
    pickupOrdersAccepted: true,
    pickupMaxDaysOut: 12,
    pickupSevenPlusDaysOrdering: true,
    deliveryOrdersAccepted: true,
    pickupOrderHours: [
      {
        dayOfWeek: 'TUESDAY',
        startTime: '',
        endTime: '',
        timeSlots: [
          { startTime: '02:00:00', endTime: '05:30:00' },
          { startTime: '15:00:00', endTime: '17:00:00' },
        ],
      },
      {
        dayOfWeek: 'WEDNESDAY',
        startTime: '',
        endTime: '',
        timeSlots: [
          { startTime: '03:00:00', endTime: '05:00:00' },
          { startTime: '06:00:00', endTime: '06:30:00' },
          { startTime: '20:00:00', endTime: '20:30:00' },
        ],
      },
      {
        dayOfWeek: 'FRIDAY',
        startTime: '',
        endTime: '',
        timeSlots: [
          { startTime: '10:00:00', endTime: '10:30:00' },
          { startTime: '20:00:00', endTime: '22:30:00' },
        ],
      },
      {
        dayOfWeek: 'MONDAY',
        startTime: '',
        endTime: '',
        timeSlots: [{ startTime: '19:00:00', endTime: '19:30:00' }],
      },
      {
        dayOfWeek: 'SATURDAY',
        startTime: '',
        endTime: '',
        timeSlots: [{ startTime: '01:00:00', endTime: '02:30:00' }],
      },
    ],
    deliveryOrderHours: [
      {
        dayOfWeek: 'TUESDAY',
        startTime: '',
        endTime: '',
        timeSlots: [{ startTime: '02:00:00', endTime: '05:30:00' }],
      },
      {
        dayOfWeek: 'MONDAY',
        startTime: '08:00:00',
        endTime: '23:00:00',
        timeSlots: [
          { startTime: '08:00:00', endTime: '23:00:00' },
          { startTime: '01:00:00', endTime: '01:30:00' },
        ],
      },
      {
        dayOfWeek: 'THURSDAY',
        startTime: '',
        endTime: '',
        timeSlots: [{ startTime: '06:00:00', endTime: '12:30:00' }],
      },
      {
        dayOfWeek: 'WEDNESDAY',
        startTime: '',
        endTime: '',
        timeSlots: [
          { startTime: '06:00:00', endTime: '06:30:00' },
          { startTime: '20:00:00', endTime: '22:30:00' },
        ],
      },
    ],
    dynamicDeliveryCharge: {
      chargeId: null,
      extChargeId: null,
      chargeName: null,
      chargeDescription: 'test ppppp',
      chargeType: 'AMOUNT',
      amount: 5000,
      percentage: null,
      taxable: false,
      gratuity: false,
      delivery: false,
      orderApplied: null,
      applicableOrderTypes: ['DELIVERY'],
      extTaxId: null,
      taxes: [],
      applicableEntity: 'ORDER',
      rules: [],
      chargeApplied: null,
      chargeTiers: [
        {
          amount: 7,
          percentage: null,
          extChargeId: null,
          minDistance: 0.0,
        },
      ],
    },
    pickupTemporaryHours: [
      {
        startDate: DateTime.now().toFormat('yyyy-LL-dd'),
        endDate: DateTime.now().plus({ days: 1 }).toFormat('yyyy-LL-dd'),
        sameHoursPerDate: {
          dayOfWeek: 'WEDNESDAY',
          startTime: null,
          endTime: null,
          timeSlots: [
            {
              startTime: '02:00:00',
              endTime: '03:00:00',
            },
          ],
        },
        diffHoursPerDate: null,
      },
      {
        startDate: DateTime.now().minus({ days: 2 }).toFormat('yyyy-LL-dd'),
        endDate: DateTime.now().minus({ days: 2 }).toFormat('yyyy-LL-dd'),
        sameHoursPerDate: {
          dayOfWeek: 'WEDNESDAY',
          startTime: null,
          endTime: null,
          timeSlots: [
            {
              startTime: '02:00:00',
              endTime: '03:00:00',
            },
          ],
        },
        diffHoursPerDate: null,
      },
    ],
    deliveryTemporaryHours: [
      {
        startDate: DateTime.now().toFormat('yyyy-LL-dd'),
        endDate: DateTime.now().toFormat('yyyy-LL-dd'),
        sameHoursPerDate: {
          dayOfWeek: 'WEDNESDAY',
          startTime: null,
          endTime: null,
          timeSlots: [
            {
              startTime: '06:00:00',
              endTime: '09:00:00',
            },
          ],
        },
        diffHoursPerDate: null,
      },
    ],
    deliveryOffDays: [DateTime.now().toFormat('yyyy-LL-dd')],
    pickupOffDays: [DateTime.now().plus({ days: 3 }).toFormat('yyyy-LL-dd')],
    deliveryRadius: 100.0,
    latitude: 39.63953,
    longitude: -92.76855,
    deliveryAvailabilityInterval: 10,
    pickupAvailabilityInterval: 10,
    extendedAttributes: {
      OTHER_PAYMENT_GUID: '68a283e4-344e-4e3e-886d-979c9ac01698',
      DELIVERY_DINING_OPTION_GUID: '491b6e2d-e87b-4feb-8f3b-7af4710fc7c3',
      DELIVERY_PICKUP_ADDRESS:
        '{"street1":"12 brookline","city":"brookline","state":"MA","postalCode":"01109","country":"US"}',
      TOAST_RESTAURANT_ID: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
      OPEN_DISCOUNT_GUID: '439e3e7b-62ca-466f-8e5c-59d149cf9720',
      PICKUP_DINING_OPTION_GUID: '2105b4d9-91b0-476e-a9e8-de4d98bfe3d6',
    },
    locationName: 'Boston QA (Incentivio DON"T EDIT)',
    externalOrderingEnabled: false,
    externalOrderingText: '',
    showPickupTimeSlots: true,
    showDeliveryTimeSlots: true,
    pickupAsapSupported: true,
    deliveryAsapSupported: true,
    countryCode: null,
    currencyCode: 'USD',
    menuImportConfig: {
      connectorGatewayName: 'incentivio-connector-toast',
      extStoreId: null,
      defaultLanguage: 'EN',
      connectorName: '',
      overrideExistingImages: false,
      importType: 'INDEPENDANT_MENU_IMPORT',
      extendedAttributes: {
        test: 'attr',
        EXT_STORE_GUID: 'toast guid',
        OVERRIDE_DISPLAYINFO_TITLE: 'true',
        OVERRIDE_DISPLAYINFO_DESCRIPTIONS: 'false',
      },
    },
    orderThrottleConfig: [
      {
        applicableOrderTypes: ['DELIVERY'],
        throttleSettings: {
          WEDNESDAY: [
            {
              timeSlot: { startTime: '08:00:00', endTime: '23:00:00' },
              throttleSettings: [
                {
                  orderAmount: 0,
                  processingTime: 10,
                  displayMessage: { EN: 'need 25 min' },
                },
                {
                  orderAmount: 10000,
                  processingTime: 30,
                  displayMessage: { EN: 'Need 30 min' },
                },
              ],
            },
          ],
        },
      },
      {
        applicableOrderTypes: ['PICKUP'],
        throttleSettings: {
          MONDAY: [
            {
              timeSlot: { startTime: '08:00:00', endTime: '23:59:59' },
              throttleSettings: [
                {
                  orderAmount: 0,
                  processingTime: 20,
                  displayMessage: { EN: 'Need 50 min extra time.' },
                },
                {
                  orderAmount: 20000,
                  processingTime: 40,
                  displayMessage: { EN: 'need 40 min' },
                },
              ],
            },
          ],
          SUNDAY: [
            {
              timeSlot: { startTime: '00:00:00', endTime: '20:20:20' },
              throttleSettings: [
                {
                  orderAmount: 0,
                  processingTime: 10,
                  displayMessage: { EN: 'asdf' },
                },
                {
                  orderAmount: 10000,
                  processingTime: 50,
                  displayMessage: { EN: 'Need 50 mins' },
                },
              ],
            },
          ],
        },
      },
    ],
    kitchenThrottleConfig: kitchenThrottleConfig.kitchenThrottleConfig,
    pickupOrderValueLimits: null,
    deliveryOrderValueLimits: null,
    catalogOverrides: [
      {
        catalogId: '6611784949f61204ffc49480',
        groupId: null,
        applicableOrderTypes: ['DELIVERY'],
        override: {
          TUESDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }],
          WEDNESDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }],
        },
      },
    ],
    groupOverrides: [
      {
        catalogId: '6611784949f61204ffc494ba',
        groupId: '6611784949f61204ffc494b4',
        applicableOrderTypes: ['DELIVERY', 'PICKUP'],
        override: { TUESDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }] },
      },
      {
        catalogId: '6611784949f61204ffc49480',
        groupId: '6611784949f61204ffc4946d',
        applicableOrderTypes: ['PICKUP'],
        override: {
          TUESDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }],
          WEDNESDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }],
          THURSDAY: [{ startTime: '09:00:00', endTime: '15:00:00' }],
        },
      },
    ],
    orderNotificationRecipientEmailList: ['dinusha.a@aeturnum.com'],
    failureNotificationRecipientEmailList: [
      'chamali.p@aeturnum.com',
      'dinusha.a@aeturnum.com',
    ],
    pickupOrderOptions: [
      {
        optionName: 'pickup 2',
        displayRank: 2,
        enableInformationField: false,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: false,
        channelsForOrderReceivedNotification: ['EMAIL'],
        channelsForOrderCompleteNotification: ['EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'pickup 2',
            informationField: null,
            imHereResponseMessage: null,
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: null,
            smsOrderClosedMessage: null,
          },
        ],
      },
      {
        optionName: 'Pickup-SMS',
        displayRank: 4,
        enableInformationField: false,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: false,
        channelsForOrderReceivedNotification: ['EMAIL'],
        channelsForOrderCompleteNotification: ['EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'pickup-SMS',
            informationField: null,
            imHereResponseMessage: null,
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: null,
            smsOrderClosedMessage: null,
          },
        ],
      },
      {
        optionName: 'DINEIN',
        displayRank: 1,
        enableInformationField: false,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: true,
        channelsForOrderReceivedNotification: ['EMAIL'],
        channelsForOrderCompleteNotification: ['EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'DINEIN',
            informationField: null,
            imHereResponseMessage: 'Thanks for the order',
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: null,
            smsOrderClosedMessage: null,
          },
        ],
      },
      {
        optionName: 'pickup 3',
        displayRank: 3,
        enableInformationField: true,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: false,
        channelsForOrderReceivedNotification: ['SMS', 'EMAIL'],
        channelsForOrderCompleteNotification: ['SMS', 'EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'pickup 3',
            informationField: 'TESTING REASON ADDED WITH UPPER CAS',
            imHereResponseMessage: null,
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: 'sms message',
            smsOrderClosedMessage: 'sms message',
          },
        ],
      },
    ],
    deliveryOrderOptions: [
      {
        optionName: 'DRIVETHRU',
        displayRank: 1,
        enableInformationField: true,
        makeInformationFieldMandatory: false,
        enableInstructions: true,
        enableImHere: true,
        channelsForOrderReceivedNotification: ['EMAIL'],
        channelsForOrderCompleteNotification: ['EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'Curbside',
            informationField: 'car make model',
            imHereResponseMessage: 'Thank you',
            errorMessageIfInformationFieldIsEmpty: null,
            instructions:
              "curbside When you get to our location, park in any spot and open your trunk. We'll bring your food out! If you dont see us within five minutes please call 555-222-3333, +555-222-3333,   or fill this form https://hottable.com/contact-us/\n\nSite - https://en.wikipedia.org/wiki/Car\nmailto:shamin.g@aeturnum.com?subject=Mailfrom",
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: null,
            smsOrderClosedMessage: null,
          },
        ],
      },
      {
        optionName: 'SMS -delivery',
        displayRank: 2,
        enableInformationField: false,
        makeInformationFieldMandatory: false,
        enableInstructions: false,
        enableImHere: false,
        channelsForOrderReceivedNotification: ['SMS', 'EMAIL'],
        channelsForOrderCompleteNotification: ['SMS', 'EMAIL'],
        displayMessage: [
          {
            langCode: 'EN',
            title: 'SMS -Delivery',
            informationField: null,
            imHereResponseMessage: null,
            errorMessageIfInformationFieldIsEmpty: null,
            instructions: null,
            orderConfirmationMessage:
              'Thank you for placing an order at our [#Location#] location, [#Customer#]! Your order has been received.\nYour [#Order Option Display Title#] order will be completed at [#Required Time#].',
            orderClosedMessage:
              'Your [#Order Type#] order is complete!\nIf this is a pickup order, please pickup your food at our [#Location#] location.\nIf this is a Delivery order, you can expect to receive your order at [#Required Time#].',
            smsOrderConfirmationMessage: 'sms message',
            smsOrderClosedMessage: 'sms message',
          },
        ],
      },
    ],
    primaryLocation: true,
    primaryLocationId: null,
    extPosLocationId: '1303e122-14d6-46c7-9aa6-9cfd0a2e849e',
    deliveryArea: { deliveryAreaType: 'CIRCLE', deliveryAreaPolygon: null },
    deliveryMaxDaysOut: 0,
    deliverySevenPlusDaysOrdering: false,
    disableTipping: false,
    primaryStore: null,
    relatedStores: [],
    qalocation: false,
    test: false,
  },
  {
    ...baseLocation,
    locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
    extPosLocationId: undefined,
  },
  {
    ...baseLocation,
    locationId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
    primaryLocation: false,
    primaryLocationId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
    extPosLocationId: '8e8c7ec2-6c41-4520-8898-83c705d6e1cd',
    ...relatedLocations,
  },
  {
    ...baseLocation,
    locationId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
    primaryLocation: true,
    primaryLocationId: null,
    extPosLocationId: '1303e122-14d6-46c7-9aa6-9cfd0a2e849e',
    ...relatedLocations,
    primaryStore: null,
  },
  {
    ...baseLocation,
    locationId: 'e1d0bb4b-3b66-4c4a-a83b-e9c28cee5ed4',
    primaryLocation: true,
    primaryLocationId: null,
    extPosLocationId: null,
  },
];
